// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_jmH","cls2":"FocusedNav-cls2__U0 FocusedNav-cls1_jmH"};